import 'alpinejs';
import 'lazysizes';
import Swup from 'swup';

// Work Filter Alpine.js Component
document.addEventListener('alpine:init', () => {
    Alpine.data('workFilter', () => ({
        activeServiceFilter: null,
        activeClientFilter: null,
        
        init() {
            console.log('Work filter initialized');
        },
        
        filterByService(serviceId) {
            console.log('Filtering by service:', serviceId);
            this.activeServiceFilter = serviceId;
            this.updateVisibleEntries();
        },
        
        filterByClient(clientId) {
            console.log('Filtering by client:', clientId);
            this.activeClientFilter = clientId;
            this.updateVisibleEntries();
        },
        
        updateVisibleEntries() {
            const entries = document.querySelectorAll('.work-entry');
            console.log('Updating entries, found:', entries.length);
            
            entries.forEach(entry => {
                const services = entry.dataset.services ? entry.dataset.services.split(',') : [];
                const clients = entry.dataset.clients ? entry.dataset.clients.split(',') : [];
                
                const serviceMatch = this.activeServiceFilter === null || 
                    services.includes(this.activeServiceFilter.toString());
                const clientMatch = this.activeClientFilter === null || 
                    clients.includes(this.activeClientFilter.toString());
                
                if (serviceMatch && clientMatch) {
                    entry.style.display = 'block';
                } else {
                    entry.style.display = 'none';
                }
            });
        }
    }));
});

// Also register as a global function for direct access
window.workFilter = () => ({
    activeServiceFilter: null,
    activeClientFilter: null,
    
    init() {
        console.log('Work filter initialized');
    },
    
    filterByService(serviceId) {
        console.log('Filtering by service:', serviceId);
        this.activeServiceFilter = serviceId;
        this.updateVisibleEntries();
    },
    
    filterByClient(clientId) {
        console.log('Filtering by client:', clientId);
        this.activeClientFilter = clientId;
        this.updateVisibleEntries();
    },
    
    updateVisibleEntries() {
        const entries = document.querySelectorAll('.work-entry');
        console.log('Updating entries, found:', entries.length);
        
        entries.forEach(entry => {
            const services = entry.dataset.services ? entry.dataset.services.split(',') : [];
            const clients = entry.dataset.clients ? entry.dataset.clients.split(',') : [];
            
            const serviceMatch = this.activeServiceFilter === null || 
                services.includes(this.activeServiceFilter.toString());
            const clientMatch = this.activeClientFilter === null || 
                clients.includes(this.activeClientFilter.toString());
            
            if (serviceMatch && clientMatch) {
                entry.style.display = 'block';
            } else {
                entry.style.display = 'none';
            }
        });
    }
});

// Scroll to top logic
var scrollTop = document.getElementById("scrollTop");
var rootElement = document.documentElement;

function scrollToTop() {
    rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}


if (scrollTop) {
    scrollTop.addEventListener("click", scrollToTop);
}

$(document).ready(function() {
  $('html').removeClass('is-animating');
});

// Check if required containers exist before initializing Swup
const requiredContainers = ["#swup", "#myNav", "#myFooter"];
const missingContainers = requiredContainers.filter(selector => !document.querySelector(selector));

let swup;
if (missingContainers.length === 0) {
    const options = {
        containers: requiredContainers,
        linkSelector: 'a.anim-link',
        animationSelector: '[class*="my-transition-"]'
    };
    
    try {
        swup = new Swup(options);
        console.log('Swup initialized successfully');
    } catch (error) {
        console.warn('Swup initialization failed:', error);
    }
} else {
    console.warn('Swup not initialized - missing containers:', missingContainers);
}

if (swup) {
    swup.on('contentReplaced', function () {
        window.scrollTo(0, 0);

        // Re-initialize scroll to top button if it exists
        var scrollTop = document.getElementById("scrollTop");
        if (scrollTop) {
            scrollTop.addEventListener("click", scrollToTop);
        }
        
    });
} else {
// Fallback: Re-initialize scroll to top button on page load if Swup isn't available
document.addEventListener('DOMContentLoaded', function() {
    var scrollTop = document.getElementById("scrollTop");
    if (scrollTop) {
        scrollTop.addEventListener("click", scrollToTop);
    }
    
});
}
